/* eslint-disable */
export default ({
    Date: date,
	Title,
    Summary,
    Url,
	CapabilityTags,
    ThumbnailLarge,
    ThumbnailAlt,
	Language,
}) => `
<article class="col-12 col-sm-12 col-lg-6 col-xl-6 c-article-listing__item c-article-listing__item--hidden c-article-listing__item--article">
    <div class="c-content-block">
        <div class="c-content-block__content-wrapper">
            <div class="c-content-block__meta">
                <span class="c-content-block__meta-date">${date || ''}</span>
				<span class="c-content-block__meta-tags">
                ${
                    CapabilityTags ? `${CapabilityTags.map(function (e) {
						return `<a href="/${Language}/content-hub/category/${e["Key"]}/">${e["Value"]}</a>`
					}).join(', ')}` : ''
                }
				<span>
            </div>
            ${
                Title ? `
                    <h3 class="c-content-block__title"><a href="${Url}" title="${Summary}">${Title}</a></h3>
                `
                : ''
            }
            ${
                Summary ? `
                    <p class="c-content-block__summary">${Summary}</p>
                `
                : ''
            }
            ${
                Url ? `
				
                    <a href="${Url}" title="${Title}" class="c-content-block__cta e-button">
                    <svg width="26px" height="27px" viewBox="0 0 26 27" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-46.000000, -505.000000)"><g transform="translate(46.000000, 502.500000)"><g transform="translate(0.000000, 3.000000)"><circle stroke="#a080fb" cx="13" cy="13" r="12.5"></circle><polygon fill="#a080fb" transform="translate(13.000000, 13.000000) rotate(-180.000000) translate(-13.000000, -13.000000) " points="20 12 9.83 12 13.41 8.41 12 7 6 13 12 19 13.41 17.59 9.83 14 20 14"></polygon></g></g></g></g></svg>
                    Read more
                    </a>
                `
                : ''
            }
        </div>
    </div>
</article>`;
/* eslint-enable */
